<template>
  <div v-show="show">
    <el-card class="box-card">
      <div
          id="device-troubleshooting"
          slot="header"
          class="clearfix troubleshooting">
        <span class="header-item">This account needs attention! </span>
      </div>
      <div class="card-content">
        <el-table
            :data="data"
            style="width: 100%">
          <el-table-column
              prop="tag"
              label="Tag"
              sortable
              width="200">
            <template slot-scope="scope">
              <span style="word-break: break-word">{{ scope.row.display_name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Instruction">
            <template slot-scope="scope">
              <section
                  style="word-break: normal"
                  v-html="scope.row.instruction" />
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>


<script>
export default {
  name: "Troubleshooting",
  props: {
    data: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
  },
  computed: {
    show() {
      return this.data.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.el-card__header > .troubleshooting {
  color: $--color-white;
  background-image: linear-gradient(
    252deg,
    #fd9646 0%,
    rgba(236, 95, 59, 0.9) 100%
  );
  border-radius: 18px 18px 0 0;
  font-size: $--font-size-large;
}

:deep(.el-card__header) {
  padding-right: 0 !important;
}
</style>
